import{a as e,b as s}from"./chunk-ZLVSXJ4T.js";import{a,d as p,m as t}from"./chunk-HBP5N4FR.js";t();s();import d from"react";var x=S=>{var r=S,{shard:n}=r,o=p(r,["shard"]);return d.createElement("span",a({},o),e(n))};export{x as a};
//# sourceMappingURL=chunk-7QDGQ657.js.map
